import {
  ARCHIVE_ACKNOWLEDGEMENT,
  UNPAID_INVOICES_ACKNOWLEDGEMENT,
  commitmentsFromRejection,
  unpaidInvoicesFromRejection
} from "../../Projects/api/pending-commitments.ts"
import type {
  StatusChangeOptions,
  StatusChangeOutcome
} from "../components/ProjectStatusSelector.tsx"

type Acknowledgement = Partial<
  typeof ARCHIVE_ACKNOWLEDGEMENT & typeof UNPAID_INVOICES_ACKNOWLEDGEMENT
>

export const sendStatusChange = async (
  send: (acknowledgement: Acknowledgement) => PromiseLike<unknown>,
  options?: StatusChangeOptions
): Promise<StatusChangeOutcome> => {
  try {
    await send({
      ...(options?.cancelAppointments ? ARCHIVE_ACKNOWLEDGEMENT : {}),
      ...(options?.acknowledgeUnpaidInvoices
        ? UNPAID_INVOICES_ACKNOWLEDGEMENT
        : {})
    })
  } catch (e) {
    return commitmentsFromRejection(e) ?? unpaidInvoicesFromRejection(e)
  }
}
